import { render, staticRenderFns } from "./benefits-preview.vue?vue&type=template&id=65c7fbaa&scoped=true"
import script from "./benefits-preview.vue?vue&type=script&lang=js"
export * from "./benefits-preview.vue?vue&type=script&lang=js"
import style0 from "./benefits-preview.vue?vue&type=style&index=0&id=65c7fbaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7fbaa",
  null
  
)

export default component.exports